<template>
  <div class="body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main>
        <div class="p-3">
          <el-row :gutter="10">
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search"></label>
                <el-input
                  placeholder="بحث باسم المنتج"
                  @keyup.native="filterByName"
                  autofocus
                  type="text"
                  v-model="productName"
                  @focus="$event.target.select()"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <el-select
                multiple
                v-model="selectedCategory"
                clearable
                placeholder="بحث بالتصنيف"
                @change="filterByCategory"
              >
                <el-option
                  v-for="item in productCategories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="searchForm">
                <label for="code"></label>
                <el-input
                  placeholder="بحث باسم الكود"
                  autofocus
                  @keyup.native="filterByCode"
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <el-select
                placeholder="المطلوب"
                @change="filterByRequired"
                v-model="requiredKey"
              >
                <el-option
                  v-for="item in required"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :lg="2" :pull="7">
              <el-button
                type="success"
                icon="el-icon-printer"
                @click="printAllProducts"
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
          v-infinite-scroll="loadMoreData"
          style="overflow: auto; width: 100%"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column label="اسم المنتج" prop="name"> </el-table-column>
          <el-table-column width="90" label="سعر البيع" prop="sale_price">
          </el-table-column>
          <el-table-column width="150" label="التصنيف" prop="category_name">
          </el-table-column>
          <el-table-column
            width="90"
            label="حد الطلب"
            prop="pivot.min_threshold"
          >
          </el-table-column>
          <el-table-column width="100" sortable label="المخزون">
            <template slot-scope="scope">
              <span>{{
                scope.row.pivot.qty / scope.row.units_per_package
              }}</span>
              -
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" sortable label="الفرعية">
            <template slot-scope="scope">
              <span>{{ scope.row.pivot.qty }}</span>
            </template>
          </el-table-column>
          <el-table-column label="مطلوب شراء">
            <template slot-scope="scope">
              <input v-model="scope.row.num" />
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ProductsAside from "@/components/ProductsAside.vue";
// import { ipcRenderer } from "electron";
export default {
  name: "Products",

  // components: { ProductsAside },

  data() {
    return {
      stock: "",
      editFormVisible: false,
      tableData: [],
      allData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      productName: "",
      selectedCategory: "",
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      current_page: 1,
      page_limit: 1,
      num: 0,
      required: [
        { name: "الكل", id: "all" },
        { name: "المطلوب فقط", id: "required" },
      ],
      requiredKey: "",
    };
  },
  created() {
    this.getOutStockProducts();
    this.getCategories();
  },
  methods: {
    getOutStockProducts() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `products-to-order/1?page=${this.pagination.current_page}`;
      axiosApi
        .get(url)
        .then((res) => {
          console.log(res.data[0].products_to_order);
          res.data[0].products_to_order.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          localStorage.setItem(
            "outStockProuducts",
            JSON.stringify(this.tableData)
          );
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getOutStockProducts();
      }
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    filterByName() {
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("outStockProuducts")
      );
      if (this.productName !== "") {
        for (let index = 0; index < outStockProuducts.length; index++) {
          if (outStockProuducts[index].name.match(this.productName)) {
            newData.push(outStockProuducts[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
    },
    filterByCode() {
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("outStockProuducts")
      );
      if (this.searchCode !== "") {
        for (let index = 0; index < outStockProuducts.length; index++) {
          if (outStockProuducts[index].code.toString().match(this.searchCode)) {
            newData.push(outStockProuducts[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
    },
    filterByCategory() {
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("outStockProuducts")
      );
      if (this.selectedCategory.length > 0) {
        for (let index = 0; index < outStockProuducts.length; index++) {
          for (let i = 0; i < this.selectedCategory.length; i++) {
            if (
              outStockProuducts[index].product_category_id ==
              this.selectedCategory[i]
            ) {
              newData.push(outStockProuducts[index]);
            }
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
    },
    printAllProducts() {
      // window.ipcRenderer = ipcRenderer;
      // let search = "";
      // if (this.productName !== "") {
      //   search = this.productName;
      // } else if (this.searchCode !== "") {
      //   search = +this.searchCode;
      // }
      // let data = {
      //   data: this.tableData,
      //   type: "productsOutStockReport",
      //   searchKey: search,
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    filterByRequired() {
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("outStockProuducts")
      );
      if (this.requiredKey == "required") {
        for (let index = 0; index < this.tableData.length; index++) {
          if (this.tableData[index].num > 0) {
            newData.push(this.tableData[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 90%;
  overflow-y: scroll;
}
</style>
